import { AfterViewInit, Component, Input, OnDestroy, OnInit } from "@angular/core";

import { Observable, Subscription } from "rxjs";

import { Pending } from "../../../shared-library/decorators/pending.decorator";
import { PaginationOptionsModel } from "../../../shared-library/form-controls/pagination/pagination-options.model";
import { DisposeMixin, EmptyClassInstance } from "../../../shared-library/mixins/dispose.mixin";
import { LockMixin } from "../../../shared-library/mixins/lock.mixin";
import { BrowserWindowService } from "../../../shared-library/services/environment/browser-window.service";

import { BaseSearchTabConfigModel } from "../../models/base-search-tab-config.model";
import { PaginationOptionsFactoryService } from "../../services/pagination-options-factory.service";

import { ContentSearchForm } from "./forms/content-search.form";
import { SearchParametersModel } from "./models/search-parameters.model";
import { SearchResultsModel } from "./models/search-results.model";
import { SearchTabConfigModel } from "./models/search-tab-config.model";
import { ContentSearchParametersFactoryService } from "./services/content-search-parameters-factory.service";
import { ContentSearchService } from "./services/content-search.service";

declare function externalUpdateActiveSearchTabFn(): any;

@Component({
    selector: "pcg-ng-content-search",
    template: require('./content-search.component.html')
})
export class ContentSearchComponent extends DisposeMixin(LockMixin(EmptyClassInstance)) implements OnInit, AfterViewInit, OnDestroy {
    @Input()
    public searchTabConfig: SearchTabConfigModel;

    @Input()
    public onTabActivated: Observable<BaseSearchTabConfigModel>;

    public searchForm: ContentSearchForm;
    public searchResult: SearchResultsModel;

    public paginationOptions: PaginationOptionsModel;

    @Pending
    private _searchInProgressSubscription: Subscription;

    private _formChangedSubscription: Subscription;
    private _formSubmittedSubscription: Subscription;
    private _tabActivatedSubscription: Subscription;

    public constructor(
        private _browserWindowService: BrowserWindowService,
        private _paginationOptionsFactory: PaginationOptionsFactoryService,
        private _searchParametersFactory: ContentSearchParametersFactoryService,
        private _searchService: ContentSearchService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.paginationOptions = this._paginationOptionsFactory.createDefaultPaginationOptions();

        const initialSearchParams = this._searchParametersFactory.createFromQueryString(this._browserWindowService.getQueryString(), this.searchTabConfig);
        const emptySearchParams = this._searchParametersFactory.createFromQueryString("", this.searchTabConfig);

        this.searchForm = ContentSearchForm.createForm(initialSearchParams, emptySearchParams);

        this._formChangedSubscription = this.searchForm.onFormChanged.subscribe(
            (searchParams: SearchParametersModel) => {
                return this.invokeSearch(searchParams);
            }
        );

        this._formSubmittedSubscription = this.searchForm.onFormSubmitted.subscribe(
            (searchParams: SearchParametersModel) => {
                return this.invokeSearch(searchParams);
            }
        );

        this._tabActivatedSubscription = this.onTabActivated.subscribe((tab) => this.onTabActivatedHandler(tab));
    }

    public ngAfterViewInit(): void {
        this.searchForm.submit();
    }

    public ngOnDestroy(): void {
        this.dispose();
        this.searchForm.dispose();
    }

    private onTabActivatedHandler(activatedTab: BaseSearchTabConfigModel): void {
        if (activatedTab.tabAlias === this.searchTabConfig.tabAlias) {
            this._browserWindowService.setQueryString(this._searchParametersFactory.serialiseToQueryString(this.searchForm.formValue));
            externalUpdateActiveSearchTabFn();
        }
    }

    private invokeSearch(searchParams: SearchParametersModel): void {
        if (this.searchTabConfig.isActive) {
            this._browserWindowService.setQueryString(this._searchParametersFactory.serialiseToQueryString(searchParams));
    }

        this._searchInProgressSubscription = this._searchService.getSearchResults(searchParams).subscribe(
            (result: SearchResultsModel) => {
                this.searchResult = result;
                window.scrollTo(0, 0);
            },
            () => {
            }
        );
    }
}
